import { Locale } from "date-fns";
import de from "date-fns/esm/locale/de";
import enGB from "date-fns/esm/locale/en-GB";
import { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const DEFAULT_LOCALE = "en-GB";

const localeMap: Record<string, Locale> = {
    [DEFAULT_LOCALE]: enGB,
    "de-DE": de,
};

export const DatePickerProvider = ({ children }: PropsWithChildren) => {
    const {
        i18n: { language },
    } = useTranslation();

    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={localeMap[language] ?? localeMap[DEFAULT_LOCALE]}
        >
            {children}
        </LocalizationProvider>
    );
};
